import { useTranslation } from "react-i18next";

export default function Marquee() {
  const { t } = useTranslation();

  return (
    <>
      <div className="w-full h-[3px] bg-[#111111] mb-2"></div>
      <div className="w-full h-[5px] bg-[#111111] mb-2"></div>
      <div className="w-full h-[8px] bg-[#111111] mb-2"></div>

      <div className="w-full bg-[#2563eb] overflow-hidden py-8">
        <div className="marquee">
          <div className="marquee-track">
            {/* İlk set */}
            <span>{t("marquee_title")}</span>
            <span>{t("marquee_title2")}</span>
            <span>{t("marquee_title3")}</span>
            <span>{t("marquee_title4")}</span>
            <span>{t("marquee_title5")}</span>

            {/* Kopya set (kesintisiz loop için) */}
            <span>{t("marquee_title")}</span>
            <span>{t("marquee_title2")}</span>
            <span>{t("marquee_title3")}</span>
            <span>{t("marquee_title4")}</span>
            <span>{t("marquee_title5")}</span>
          </div>
        </div>

        <style>{`
          .marquee {
            width: 100%;
            overflow: hidden;
          }

          .marquee-track {
            display: flex;
            width: max-content;
            animation: marquee 15s linear infinite;
          }

          .marquee-track span {
            white-space: nowrap;
            font-weight: 800;
            color: #ffffff !important;
            padding-right: 4rem;
            font-size: clamp(28px, 6vw, 42px);
          }

          @keyframes marquee {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }
        `}</style>
      </div>
    </>
  );
}